enum OperatingLeaseProductsLegalEntityEnum {
    OLPO24 = "OLPO24",
    OLPO36 = "OLPO36",
}

export default OperatingLeaseProductsLegalEntityEnum;
